import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import AdminSubHeader from "../../layouts/partials/AdminSubheader";
import { COMPANIES_ACTIONS } from "../../../redux/companies/actions";
import {
  selectCompanies,
  companiesCreating,
  companiesLoaded,
  companiesMeta,
  companiesFilters
} from "../../../redux/companies/selectors";
import Confirm from "../../../base/Confirm";
import { selectVenues } from "../../../redux/venues/selectors";
import ListView from "../../../base/ListView";
import { dateRender } from "../../../libs/utils";
import queryString from "query-string";

class _Companies extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      companies: this.props.companies,
      companiesLoaded: this.props.companiesLoaded,
      filters: this.props.filters
    };

    this._handleCreate = this._handleCreate.bind(this);
    this._handleUpdate = this._handleUpdate.bind(this);
    this._handleDelete = this._handleDelete.bind(this);
    this._handleFilterUpdate = this._handleFilterUpdate.bind(this);
  }

  static propTypes = {
    companies: PropTypes.array,
    companiesLoaded: PropTypes.bool,
    loadCompanies: PropTypes.func,
    createCompany: PropTypes.func,
    updateCompany: PropTypes.func,
    deleteCompany: PropTypes.func,
    venues: PropTypes.array,
    match: PropTypes.object,
    companyMeta: PropTypes.object,
    filters: PropTypes.object,
    updateFilters: PropTypes.func
  };

  UNSAFE_componentWillMount() {
    const filters = {
      ...this.props.filters,
      ...queryString.parse(window.location.search)
    };
    this.props.updateFilters(filters);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const newState = {
      companies: nextProps.companies,
      companiesLoaded: nextProps.companiesLoaded
    };

    this.setState(newState);
  }

  _handleFilterUpdate(filters) {
    this.props.updateFilters(filters);
  }

  _handleCreate(values) {
    const data = {
      name: values.name
    };
    this.props.createCompany(data);
  }

  _handleUpdate(values) {
    const data = {
      name: values.name
    };

    this.props.updateCompany(values.id, data);
  }

  _handleDelete(id) {
    Confirm(
      "Are you sure you want to delete this company? This action can not be undone, please make sure no festival is using this company.",
      {
        title: "Delete Company",
        confirmStyle: "btn-danger",
        confirmText: "Delete"
      }
    ).then(
      result => {
        this.props.deleteCompany(id);
      },
      result => {}
    );
  }

  render() {
    const { companyMeta, filters } = this.props;
    const { companies, companiesLoaded } = this.state;

    const listViewConf = {
      dataSet: companies,
      dataMeta: companyMeta,
      columns: [
        {
          key: "name",
          value: "Name",
          sort: "name"
        },
        {
          key: "city",
          value: "City",
          sort: "city"
        },
        {
          key: "createdAt",
          value: "Created",
          sort: "created_at",
          render: company => dateRender(company.createdAt)
        },
        {
          key: "updatedAt",
          value: "Last Updated",
          sort: "updated_at",
          render: company => dateRender(company.updatedAt)
        }
      ],
      baseFilters: filters,
      filters: [
        {
          label: "Name",
          icon: "la-search",
          type: "text",
          key: "name"
        },
        {
          label: "City",
          icon: "la-map-marker",
          type: "text",
          key: "city"
        },
        {
          label: "Accounting customer code",
          icon: "la-money",
          type: "text",
          key: "accounting_customer_code"
        },
        {
          label: "Type",
          icon: "la-tag",
          type: "select",
          key: "type",
          dataset: [
            {
              key: "artist",
              value: "Artist"
            },
            {
              key: "company",
              value: "Company"
            },
            {
              key: "association",
              value: "Association"
            }
          ]
        }
      ],
      actions: {
        deleteLink: true,
        editLink: true,
        detailsLink: false,

        deleteFunction: this._handleDelete
      },
      url: "companies"
    };

    return [
      <AdminSubHeader title="Companies" key="subheader" breadcrumbs={[]}>
        <Link
          to="/admin/companies/create"
          className="btn btn-outline-success m-btn m-btn--icon btn-lg m-btn--icon-only m-btn--pill m-btn--air"
        >
          <i className="la la-plus" />
        </Link>
      </AdminSubHeader>,
      <div className="m-content" key="content">
        {companiesLoaded && (
          <div className="row">
            <div className="col-xl-12">
              <ListView
                config={listViewConf}
                handleFilterUpdate={this._handleFilterUpdate}
              />
            </div>
          </div>
        )}
      </div>
    ];
  }
}

const mapDispatchToProps = dispatch => ({
  loadCompanies: () => dispatch(COMPANIES_ACTIONS.loadAllRequest()),
  createCompany: values => dispatch(COMPANIES_ACTIONS.createRequest(values)),
  updateCompany: (id, values) =>
    dispatch(COMPANIES_ACTIONS.updateRequest(id, values)),
  deleteCompany: id => dispatch(COMPANIES_ACTIONS.deleteRequest(id)),
  updateFilters: filters => dispatch(COMPANIES_ACTIONS.updateFilters(filters))
});

const mapStateToProps = function(state) {
  return {
    venues: selectVenues(state),
    companies: selectCompanies(state),
    companyMeta: companiesMeta(state),
    companiesLoaded: companiesLoaded(state),
    companyCreating: companiesCreating(state),
    filters: companiesFilters(state)
  };
};

const Companies = connect(mapStateToProps, mapDispatchToProps)(_Companies);

export default Companies;
